import * as d3 from 'd3';

export default class TooltipPlugin {
    setParent(parent) {
        this.parent = parent;
    }

    init()
    {
        const tooltip = document.createElement('div');
        tooltip.classList.add('tooltip');
        tooltip.classList.add('js-tooltip');

        const tooltipContent = document.createElement('div');
        tooltipContent.classList.add('tooltip__content');
        tooltipContent.classList.add('js-text');

        this.indicator = this.parent.canvas.select('.js-indicators').append('rect')
            .attr('width', 1)
            .attr('height', this.parent.height)
            .attr('fill', '#DDD')
            .style('display', 'none');

        tooltip.appendChild(tooltipContent);
        this.parent.dom.appendChild(tooltip);
        this.tooltip = d3.select(tooltip);
        this.tooltip.attr('style', 'display: none;');
    }

    onMouseMove(event)
    {
        const x = this.parent.x;
        const padding = this.parent.padding;
        const data = this.parent.scopedData;
        const dataLength = data.length;
        
        let mouseX = dataLength * ((event.x) / this.parent.chartRwdWidth),
        left = Math.floor(mouseX),
        right = left+1,
        index = (mouseX - left < 0.5 ? left : right),
        item = data[index];

        index = index < 0 ? 0 : index;
        index = index > dataLength ? dataLength : index;
        
        const getMessage = (item) => {
            const hints = item.hint;

            return Object.keys(hints)
                .map((key) => '<div class="tooltip__row"><span class="tooltip__key">' + key + ':</span><span class="tooltip__val">' + hints[key] + '</span></div>')
                .join('');
        };
        this.indicator
            .attr('transform', 'matrix(1, 0, 0, 1,' + x(index) + ', 0)');

        this.tooltip
            .attr("style", "transform: translate(" + (event.x + padding.left) + 'px, ' + (event.y + padding.top) + 'px);');
        this.tooltip.select('.js-text')
            .node()
            .innerHTML = getMessage(item);
    }

    onMouseEnter()
    {
        this.indicator.style('display', 'block');
        this.tooltip.style('display', 'block');
    }

    onMouseLeave()
    {
        this.indicator.style('display', 'none');
        this.tooltip.style('display', 'none');
    }
}


// WEBPACK FOOTER //
// ./js/Plugins/TooltipPlugin.js